import type { RouteLocationNormalizedLoaded } from 'vue-router';

const previousRoute = ref<RouteLocationNormalizedLoaded | null>(null);

export default function usePreviousRoute() {
    return {
        previousRoute,
    };
}
